module.exports = __webpack_public_path__ + "static/media/Chield_check_light.eb9e69de.svg";